/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pronunciation_Report_WordInputs */

const en_pronunciation_report_word = /** @type {(inputs: Pronunciation_Report_WordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Word or phrase`)
};

const es_pronunciation_report_word = /** @type {(inputs: Pronunciation_Report_WordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palabra o frase`)
};

/**
* | output |
* | --- |
* | "Word or phrase" |
*
* @param {Pronunciation_Report_WordInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pronunciation_report_word = /** @type {((inputs?: Pronunciation_Report_WordInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pronunciation_Report_WordInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pronunciation_report_word(inputs)
	return en_pronunciation_report_word(inputs)
});